import { createPartyRequest } from './helper';
export const deletePartyRelation = createPartyRequest({
    source: 'data',
    method: 'delete',
    route: '/party/parties/partyrelation/:relationId',
});
